import { SimulationResult } from '../types/types';
import { useSessionCache, hashKey } from './useSessionCache';

export function buildCacheKey(
  playerPicks: string,
  knownWinners: string[],
  pointsPerRound: number[],
  roundNames: string[]
): string {
  return hashKey(JSON.stringify({ playerPicks, knownWinners, pointsPerRound, roundNames }));
}

export function useSimulationCache() {
  return useSessionCache<SimulationResult>('sim_cache_', 'sim_cache_order');
}
